import { useLocation } from 'react-router';
import useGlobalGtmListeners from '../hooks/useGlobalGtmListeners';
import usePsInitUserEvent from '../hooks/usePsInitUserEvent';
// import useGtmEventsConsumer from '../../common/hooks/useGtmEventsConsumer';

export default function GlobalGtmRegistrations() {
  useGlobalGtmListeners();

  // TODO figure out how this is related to increased number of sessions
  // useGtmEventsConsumer();

  // Trigger GTM ps_init_user event on every navigation
  usePsInitUserEvent(useLocation());

  return null;
}
